<template>
  <div class="vendor-container">
    <div class="vendor-wrapper">
      <primary-select type="text"
                      :value="vendor.vendor_product_uuid"
                      @input="handleVendorChange"
                      class="vendor-select"
                      placeholder="Enter country"
                      :options="rateList"/>
      <primary-input type="text"
                     :value="price || priceProp"
                     :disabled="true"
                     class="vendor-input"
                     placeholder="Enter rate" />
    </div>
    <div class="close-button">
      <svg @click="removeVendorItem"
            class="icon"
            width="30px"
            height="30px"
            viewBox="0 0 30 30"
            version="1.1">
        <path transform="translate(14.977556, 14.977594) rotate(45.000000) translate(-14.977556, -14.977594) "
            d="M14.9776692,5 C9.47601504,5 5,9.47593985 5,14.977594 C5,20.4792481 9.47593985,24.955188 14.977594,24.955188 C20.4792481,24.955188 24.9551128,20.4792481 24.9551128,14.977594 C24.9551128,9.47593985 20.4793233,5 14.9776692,5 Z M14.9776692,23.8273684 C10.0978195,23.8273684 6.12781955,19.8574436 6.12781955,14.977594 C6.12781955,10.0977444 10.0978195,6.12781955 14.9776692,6.12781955 C19.8573684,6.12781955 23.8273684,10.0978195 23.8273684,14.977594 C23.8273684,19.8573684 19.8573684,23.8273684 14.9776692,23.8273684 Z M18.4926901,14.3550877 L15.7499108,14.3550877 L15.7499108,11.6578947 C15.7499108,11.2944737 15.4504601,11 15.0808967,11 C14.7113333,11 14.4118826,11.2944737 14.4118826,11.6578947 L14.4118826,14.3550877 L11.6690141,14.3550877 C11.2994507,14.3550877 11,14.6495614 11,15.0129825 C11,15.3764035 11.2994507,15.6708772 11.6690141,15.6708772 L14.4117934,15.6708772 L14.4117934,18.3681579 C14.4117934,18.7315789 14.7112441,19.0260526 15.0808075,19.0260526 C15.4503709,19.0260526 15.7498216,18.7315789 15.7498216,18.3681579 L15.7498216,15.6708772 L18.4926009,15.6708772 C18.8621643,15.6708772 19.161615,15.3764035 19.161615,15.0129825 C19.161615,14.6495614 18.8621643,14.3550877 18.4926901,14.3550877 Z"
            id="path-1">
        </path>
      </svg>
    </div>
  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'AddProductVendor',
  components: {
    PrimaryInput: () => import('@/components/Inputs/PrimaryInput.vue'),
    PrimarySelect: () => import('@/components/Inputs/PrimarySelect.vue'),
  },
  props: ['index', 'mobileNetworkId', 'activeOperatorId', 'vendor', 'priceProp', 'fromIndex'],
  data: () => ({
    price: null,
  }),
  computed: {
    ...mapGetters({
      rates: 'rates/getRates',
      allVendors: 'products/getAllVendors',
    }),
    rateList() {
      if(this.rates.length === 0) {
        this.price = '';
      }
      return this.rates.map(rate => {
        return { name: rate.vendor_product_name, value: rate.vendor_product_uuid }
      })
    },
    initPrice() {
      if(this.rates.length === 0) {
        return '';
      }
      let filterd = this.rates.filter( rate => {
        return rate.vendor_product_uuid === this.vendor.vendor_product_uuid
      });
      this.price = filterd[0].price;
      return filterd[0].price;
    }
  },
  created() {
    console.log("this.fromIndex vendors--> ", this.fromIndex)
  },
  methods: {
    ...mapActions({
      updateVendor: 'routing/updateRoute',
      removeVendor: 'routing/removeRoute',    
    }),
    handleVendorChange(vendor_product_uuid) {
      this.updateVendor({ fields: { vendor_product_uuid }, index: this.fromIndex });
      this.rates.map( rate => {
        if(rate.vendor_product_uuid === vendor_product_uuid) {
          this.price = rate.price;
        }
      });
    },
    removeVendorItem(){
      this.removeVendor(this.fromIndex);
    },
  }
}
</script>

<style lang="scss" scoped>
.vendor-container {
      display: flex;
      width: 100%;
      margin-bottom: 10px;
    .vendor-wrapper {
        display: flex;
        width: calc(100% - 55px);
        justify-content: space-between;
        .vendor-select {
        width: 60%;
        }
        .vendor-input {
        width: 37%;
        }
    }
    .close-button {
        display: flex;
        align-items: center;
        width: 55px;
        justify-content: center;
        fill: #55616e;
        svg {
        cursor: pointer;
        }
    }
}
</style>

